import { combineReducers } from 'redux';

import clipping from './clipping';

export default combineReducers({
  clipping,
});
